


import React, { useState, useEffect, useMemo } from 'react';
import { DashboardHeader } from './DashboardHeader';
import { DataContractCard } from './DataContractCard';
import { DataContractDetailsModal } from './DataContractDetailsModal';
import axios from 'axios';
import heartLoading from "../../../assests/heartLoading.gif";
import { RotateCcw } from "lucide-react";
import preloader from "../../../assests/preloader1.gif";
import { mockDataProductsResponse ,mockSubscriptionsResponse} from "./TraficLight";


// Removed sample data - will use API data
const sampleDataContracts_OLD = [
  {
    id: '1',
    name: 'Customer Analytics',
    description: 'Core customer behavior and transaction data pipeline feeding ML models and business intelligence.',
    status: 'healthy',
    lastUpdated: '2 min ago',
    dataSource: 'PostgreSQL',
    consumers: 12,
    slaCompliance: 99,
    dataQuality: 98,
    freshness: '< 5 min',
    consumerDependencies: [
      {
        id: 'c1',
        name: 'Customer Segmentation ML Model',
        type: 'ml_model',
        status: 'active',
        lastAccessed: '1 min ago',
        dependencies: [
          {
            id: 'c1-1',
            name: 'Marketing Campaign Dashboard',
            type: 'dashboard',
            status: 'active',
            lastAccessed: '5 min ago'
          },
          {
            id: 'c1-2',
            name: 'Personalization API',
            type: 'api',
            status: 'active',
            lastAccessed: '2 min ago'
          }
        ]
      },
      {
        id: 'c2',
        name: 'Executive Analytics Dashboard',
        type: 'dashboard',
        status: 'active',
        lastAccessed: '3 min ago',
        dependencies: [
          {
            id: 'c2-1',
            name: 'Monthly Business Report',
            type: 'report',
            status: 'active',
            lastAccessed: '1 hour ago'
          }
        ]
      },
      {
        id: 'c3',
        name: 'Customer Service Portal',
        type: 'service',
        status: 'active',
        lastAccessed: '30 sec ago'
      }
    ]
  },
  {
    id: '2',
    name: 'Inventory Management',
    description: 'Real-time inventory levels and warehouse operations data for supply chain optimization.',
    status: 'warning',
    lastUpdated: '15 min ago',
    dataSource: 'MongoDB',
    consumers: 8,
    slaCompliance: 87,
    dataQuality: 94,
    freshness: '12 min',
    consumerDependencies: [
      {
        id: 'i1',
        name: 'Supply Chain Dashboard',
        type: 'dashboard',
        status: 'active',
        lastAccessed: '5 min ago'
      },
      {
        id: 'i2',
        name: 'Warehouse Management System',
        type: 'service',
        status: 'error',
        lastAccessed: '2 hours ago',
        dependencies: [
          {
            id: 'i2-1',
            name: 'Inventory Alert Service',
            type: 'service',
            status: 'inactive',
            lastAccessed: '3 hours ago'
          }
        ]
      },
      {
        id: 'i3',
        name: 'Procurement API',
        type: 'api',
        status: 'active',
        lastAccessed: '10 min ago'
      }
    ]
  },
  {
    id: '3',
    name: 'Financial Reporting',
    description: 'Critical financial data pipeline for regulatory compliance and executive reporting.',
    status: 'critical',
    lastUpdated: '45 min ago',
    dataSource: 'Oracle',
    consumers: 25,
    slaCompliance: 72,
    dataQuality: 85,
    freshness: '2 hours',
    consumerDependencies: [
      {
        id: 'f1',
        name: 'Regulatory Compliance System',
        type: 'service',
        status: 'error',
        lastAccessed: '1 hour ago',
        dependencies: [
          {
            id: 'f1-1',
            name: 'SEC Filing Generator',
            type: 'service',
            status: 'error',
            lastAccessed: '2 hours ago'
          },
          {
            id: 'f1-2',
            name: 'Audit Trail Service',
            type: 'service',
            status: 'inactive',
            lastAccessed: '3 hours ago'
          }
        ]
      },
      {
        id: 'f2',
        name: 'CFO Dashboard',
        type: 'dashboard',
        status: 'inactive',
        lastAccessed: '2 hours ago'
      },
      {
        id: 'f3',
        name: 'Financial Planning Model',
        type: 'ml_model',
        status: 'error',
        lastAccessed: '1.5 hours ago'
      }
    ]
  },
  {
    id: '4',
    name: 'User Activity Stream',
    description: 'High-volume user interaction and engagement metrics for product analytics.',
    status: 'healthy',
    lastUpdated: '1 min ago',
    dataSource: 'Kafka',
    consumers: 18,
    slaCompliance: 96,
    dataQuality: 99,
    freshness: '< 1 min',
    consumerDependencies: [
      {
        id: 'u1',
        name: 'Product Analytics Dashboard',
        type: 'dashboard',
        status: 'active',
        lastAccessed: '30 sec ago'
      },
      {
        id: 'u2',
        name: 'User Behavior ML Pipeline',
        type: 'ml_model',
        status: 'active',
        lastAccessed: '1 min ago',
        dependencies: [
          {
            id: 'u2-1',
            name: 'Recommendation Engine',
            type: 'service',
            status: 'active',
            lastAccessed: '45 sec ago'
          },
          {
            id: 'u2-2',
            name: 'A/B Testing Platform',
            type: 'service',
            status: 'active',
            lastAccessed: '2 min ago'
          }
        ]
      }
    ]
  },
  {
    id: '5',
    name: 'Marketing Attribution',
    description: 'Campaign performance and customer acquisition cost analysis data pipeline.',
    status: 'warning',
    lastUpdated: '8 min ago',
    dataSource: 'BigQuery',
    consumers: 6,
    slaCompliance: 91,
    dataQuality: 88,
    freshness: '8 min',
    consumerDependencies: [
      {
        id: 'm1',
        name: 'Campaign Performance Dashboard',
        type: 'dashboard',
        status: 'active',
        lastAccessed: '5 min ago'
      },
      {
        id: 'm2',
        name: 'Attribution Model',
        type: 'ml_model',
        status: 'active',
        lastAccessed: '8 min ago'
      }
    ]
  },
  {
    id: '6',
    name: 'Product Catalog',
    description: 'Master product data including pricing, availability, and specifications across all channels.',
    status: 'healthy',
    lastUpdated: '3 min ago',
    dataSource: 'Redis',
    consumers: 35,
    slaCompliance: 100,
    dataQuality: 97,
    freshness: '< 3 min',
    consumerDependencies: [
      {
        id: 'p1',
        name: 'E-commerce Platform',
        type: 'service',
        status: 'active',
        lastAccessed: '1 min ago',
        dependencies: [
          {
            id: 'p1-1',
            name: 'Product Search API',
            type: 'api',
            status: 'active',
            lastAccessed: '30 sec ago'
          },
          {
            id: 'p1-2',
            name: 'Pricing Engine',
            type: 'service',
            status: 'active',
            lastAccessed: '2 min ago'
          }
        ]
      },
      {
        id: 'p2',
        name: 'Mobile App',
        type: 'service',
        status: 'active',
        lastAccessed: '45 sec ago'
      },
      {
        id: 'p3',
        name: 'Inventory Sync Service',
        type: 'service',
        status: 'active',
        lastAccessed: '3 min ago'
      }
    ]
  }
];

function LandingPage() {
  // Tab state
  const [activeTab, setActiveTab] = useState("all");
  
  // Data states
  const [dataContracts, setDataContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterLoading, setFilterLoading] = useState(false);
  
  // Filter states
  const [parentDomain, setParentDomain] = useState("All Parent Domains");
  const [domain, setDomain] = useState("All Domains");
  const [subDomain, setSubDomain] = useState("All Sub Domains");
  const [product, setProduct] = useState("All Products");
  const [showFilters, setShowFilters] = useState(true);
  
  // Hierarchical filters from API
  const [hierarchicalFilters, setHierarchicalFilters] = useState(null);
  const [filterOptions, setFilterOptions] = useState({
    parentDomains: [],
    domains: [],
    subDomains: [],
    products: [],
  });
  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  
  // Modal states
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [selectedContract, setSelectedContract] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false)

  // Fetch traffic light data from API
  const fetchTrafficLightData = async (payload = null) => {
    try {
      const requestPayload = payload || {
        parentDomain: parentDomain === "All Parent Domains" ? "" : parentDomain,
        domain: domain === "All Domains" ? "" : domain,
        subDomain: subDomain === "All Sub Domains" ? "" : subDomain,
        product: product === "All Products" ? "" : product,
        searchValue: "",
        page: currentPage,
        pageSize: pageSize,
      };

      // Add subscribedBy for My Subscription tab
      if (activeTab === "mySubscriptions") {
        requestPayload.subscribedBy = localStorage.getItem("userId") || "";
      }

      // Use different endpoint based on active tab
      const apiEndpoint = activeTab === "mySubscriptions"
        ? `${process.env.REACT_APP_API_URL}/get-subscribed-trafficlight-results`
        : `${process.env.REACT_APP_API_URL}/get-trafficlight-results`;

      // const response = await axios.post(apiEndpoint, requestPayload);
const response = { 
  data: activeTab === "mySubscriptions"
    ? mockSubscriptionsResponse
    : mockDataProductsResponse
};
      if (response.data) {
let result = response.data.dataContracts || [];

// Apply Parent Domain Filter
if (parentDomain !== "All Parent Domains") {
  result = result.filter(c =>
    response.data.filters.parent_domains
      .find(pd => pd.parent_domain === parentDomain)
      ?.domains.some(d =>
        d.sub_domains.some(sd =>
          sd.products.includes(c.name)
        )
      )
  );
}

// Apply Domain Filter
if (domain !== "All Domains") {
  result = result.filter(c =>
    response.data.filters.parent_domains
      .find(pd => pd.parent_domain === parentDomain)
      ?.domains.find(d => d.domain === domain)
      ?.sub_domains.some(sd =>
        sd.products.includes(c.name)
      )
  );
}

// Apply Sub-Domain Filter
if (subDomain !== "All Sub Domains") {
  result = result.filter(c =>
    response.data.filters.parent_domains
      .find(pd => pd.parent_domain === parentDomain)
      ?.domains.find(d => d.domain === domain)
      ?.sub_domains.find(sd => sd.sub_domain === subDomain)
      ?.products.includes(c.name)
  );
}

// Apply Product Filter
if (product !== "All Products") {
  result = result.filter(c => c.name === product);
}

setDataContracts(result);
        setTotalCount(response.data.totalCount || 0);
        setTotalPages(response.data.totalPages || 0);
        setCurrentPage(response.data.page || 1);
        setPageSize(response.data.pageSize || 10);

        // Handle filter options from API response
        if (response.data.filters && response.data.filters.parent_domains) {
          setHierarchicalFilters(response.data.filters);

          // Extract ALL available options for each filter level
          const parentDomains = response.data.filters.parent_domains.map(
            (pd) => pd.parent_domain
          );

          // Get ALL domains
          const allDomains = [];
          response.data.filters.parent_domains.forEach((pd) => {
            pd.domains.forEach((d) => {
              if (!allDomains.includes(d.domain)) {
                allDomains.push(d.domain);
              }
            });
          });

          // Get ALL sub domains
          const allSubDomains = [];
          response.data.filters.parent_domains.forEach((pd) => {
            pd.domains.forEach((d) => {
              d.sub_domains.forEach((sd) => {
                if (!allSubDomains.includes(sd.sub_domain)) {
                  allSubDomains.push(sd.sub_domain);
                }
              });
            });
          });

          // Get ALL products
          const allProducts = [];
          response.data.filters.parent_domains.forEach((pd) => {
            pd.domains.forEach((d) => {
              d.sub_domains.forEach((sd) => {
                sd.products.forEach((p) => {
                  if (!allProducts.includes(p)) {
                    allProducts.push(p);
                  }
                });
              });
            });
          });

          setFilterOptions({
            parentDomains: parentDomains,
            domains: allDomains,
            subDomains: allSubDomains,
            products: allProducts,
          });
        }
      }
    } catch (error) {
      console.error("Error fetching traffic light data:", error);
      setDataContracts([]);
      setTotalCount(0);
      setTotalPages(0);
    } finally {
      setLoading(false);
      setFilterLoading(false);
    }
  };

  // Fetch data on component mount and when tab changes
  useEffect(() => {
    setLoading(true);
    fetchTrafficLightData();
  }, [activeTab]);

  // Show all contracts without status filtering (status filter is commented out)
  const filteredContracts = useMemo(() => {
    return dataContracts;
  }, [dataContracts]);

  const stats = useMemo(() => ({
    total: dataContracts.length,
    healthy: dataContracts.filter(c => c.status === 'healthy').length,
    warning: dataContracts.filter(c => c.status === 'warning').length,
    critical: dataContracts.filter(c => c.status === 'critical').length
  }), [dataContracts]);

  // Filter change handlers with cascading logic
  const handleParentDomainChange = (event) => {
    const newParentDomain = event.target.value;
    setParentDomain(newParentDomain);

    if (newParentDomain === "All Parent Domains") {
      setDomain("All Domains");
      setSubDomain("All Sub Domains");
      setProduct("All Products");
    } else if (hierarchicalFilters) {
      const selectedParentDomain = hierarchicalFilters.parent_domains.find(
        (pd) => pd.parent_domain === newParentDomain
      );

      if (selectedParentDomain) {
        const relatedDomains = selectedParentDomain.domains.map((d) => d.domain);

        if (relatedDomains.length === 1) {
          setDomain(relatedDomains[0]);
          const selectedDomain = selectedParentDomain.domains[0];
          const domainSubDomains = selectedDomain.sub_domains.map((sd) => sd.sub_domain);

          if (domainSubDomains.length === 1) {
            setSubDomain(domainSubDomains[0]);
            const selectedSubDomain = selectedDomain.sub_domains[0];
            const subDomainProducts = selectedSubDomain.products;

            if (subDomainProducts.length === 1) {
              setProduct(subDomainProducts[0]);
            } else {
              setProduct("All Products");
            }
          } else {
            setSubDomain("All Sub Domains");
            setProduct("All Products");
          }
        } else {
          setDomain("All Domains");
          setSubDomain("All Sub Domains");
          setProduct("All Products");
        }
      }
    }

    setCurrentPage(1);
    setFilterLoading(true);
    
    const payload = {
      parentDomain: newParentDomain === "All Parent Domains" ? "" : newParentDomain,
      domain: domain === "All Domains" ? "" : domain,
      subDomain: subDomain === "All Sub Domains" ? "" : subDomain,
      product: product === "All Products" ? "" : product,
      searchValue: "",
      page: 1,
      pageSize: pageSize,
    };

    fetchTrafficLightData(payload);
  };

  const handleDomainChange = (event) => {
    const newDomain = event.target.value;
    setDomain(newDomain);

    if (newDomain === "All Domains") {
      setSubDomain("All Sub Domains");
      setProduct("All Products");
    } else if (hierarchicalFilters) {
      const selectedParentDomain = hierarchicalFilters.parent_domains.find(
        (pd) => pd.parent_domain === parentDomain
      );

      if (selectedParentDomain) {
        const selectedDomain = selectedParentDomain.domains.find(
          (d) => d.domain === newDomain
        );

        if (selectedDomain) {
          const relatedSubDomains = selectedDomain.sub_domains.map((sd) => sd.sub_domain);

          if (relatedSubDomains.length === 1) {
            setSubDomain(relatedSubDomains[0]);
            const selectedSubDomain = selectedDomain.sub_domains[0];
            const subDomainProducts = selectedSubDomain.products;

            if (subDomainProducts.length === 1) {
              setProduct(subDomainProducts[0]);
            } else {
              setProduct("All Products");
            }
          } else {
            setSubDomain("All Sub Domains");
            setProduct("All Products");
          }
        }
      }
    }

    setCurrentPage(1);
    setFilterLoading(true);

    const payload = {
      parentDomain: parentDomain === "All Parent Domains" ? "" : parentDomain,
      domain: newDomain === "All Domains" ? "" : newDomain,
      subDomain: subDomain === "All Sub Domains" ? "" : subDomain,
      product: product === "All Products" ? "" : product,
      searchValue: "",
      page: 1,
      pageSize: pageSize,
    };

    fetchTrafficLightData(payload);
  };

  const handleSubDomainChange = (event) => {
    const newSubDomain = event.target.value;
    setSubDomain(newSubDomain);

    if (newSubDomain === "All Sub Domains") {
      setProduct("All Products");
    } else if (hierarchicalFilters) {
      const selectedParentDomain = hierarchicalFilters.parent_domains.find(
        (pd) => pd.parent_domain === parentDomain
      );

      if (selectedParentDomain) {
        const selectedDomain = selectedParentDomain.domains.find(
          (d) => d.domain === domain
        );

        if (selectedDomain) {
          const selectedSubDomain = selectedDomain.sub_domains.find(
            (sd) => sd.sub_domain === newSubDomain
          );

          if (selectedSubDomain) {
            const relatedProducts = selectedSubDomain.products;

            if (relatedProducts.length === 1) {
              setProduct(relatedProducts[0]);
            } else {
              setProduct("All Products");
            }
          }
        }
      }
    }

    setCurrentPage(1);
    setFilterLoading(true);

    const payload = {
      parentDomain: parentDomain === "All Parent Domains" ? "" : parentDomain,
      domain: domain === "All Domains" ? "" : domain,
      subDomain: newSubDomain === "All Sub Domains" ? "" : newSubDomain,
      product: product === "All Products" ? "" : product,
      searchValue: "",
      page: 1,
      pageSize: pageSize,
    };

    fetchTrafficLightData(payload);
  };

  const handleProductChange = (event) => {
    const newProduct = event.target.value;
    setProduct(newProduct);

    setCurrentPage(1);
    setFilterLoading(true);

    const payload = {
      parentDomain: parentDomain === "All Parent Domains" ? "" : parentDomain,
      domain: domain === "All Domains" ? "" : domain,
      subDomain: subDomain === "All Sub Domains" ? "" : subDomain,
      product: newProduct === "All Products" ? "" : newProduct,
      searchValue: "",
      page: 1,
      pageSize: pageSize,
    };

    fetchTrafficLightData(payload);
  };

  // Get filtered options based on current selections
  const getFilterOptions = () => {
    let availableOptions = { ...filterOptions };

    if (hierarchicalFilters && hierarchicalFilters.parent_domains) {
      if (parentDomain !== "All Parent Domains") {
        const selectedParentDomain = hierarchicalFilters.parent_domains.find(
          (pd) => pd.parent_domain === parentDomain
        );

        if (selectedParentDomain) {
          const domains = selectedParentDomain.domains.map((d) => d.domain);
          availableOptions.domains = domains;

          if (domain !== "All Domains") {
            const selectedDomain = selectedParentDomain.domains.find(
              (d) => d.domain === domain
            );
            if (selectedDomain) {
              const subDomains = selectedDomain.sub_domains.map((sd) => sd.sub_domain);
              availableOptions.subDomains = subDomains;

              if (subDomain !== "All Sub Domains") {
                const selectedSubDomain = selectedDomain.sub_domains.find(
                  (sd) => sd.sub_domain === subDomain
                );
                if (selectedSubDomain) {
                  availableOptions.products = selectedSubDomain.products;
                }
              }
            }
          }
        }
      }
    }

    return availableOptions;
  };

  const handleResetFilters = () => {
    setParentDomain("All Parent Domains");
    setDomain("All Domains");
    setSubDomain("All Sub Domains");
    setProduct("All Products");
    setCurrentPage(1);
    fetchTrafficLightData();
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    await fetchTrafficLightData();
    setIsRefreshing(false);
  };

  const handleViewDetails = (contract) => {
    setSelectedContract(contract);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedContract(null);
  };

  const handleTabChange = (newTab) => {
    setActiveTab(newTab);
    setCurrentPage(1);
  };

  const handlePageChange = async (newPage) => {
    setCurrentPage(newPage);

    const payload = {
      parentDomain: parentDomain === "All Parent Domains" ? "" : parentDomain,
      domain: domain === "All Domains" ? "" : domain,
      subDomain: subDomain === "All Sub Domains" ? "" : subDomain,
      product: product === "All Products" ? "" : product,
      searchValue: "",
      page: newPage,
      pageSize: pageSize,
    };

    await fetchTrafficLightData(payload);
  };

  if (loading) {
    return (
      <div className="relative bg-white flex items-center justify-center z-50 min-h-screen">
        <div className="flex flex-col items-center space-y-3">
          <img src={preloader} alt="Loading..." width={200} />
          <span className="text-gray-700 text-[20px] text-center">
            Loading traffic light data...
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className='min-h-screen bg-white p-2 ml-5'>
      {/* Header */}
      <div className="flex flex-col lg:flex-row lg:items-center items-center lg:justify-between">
        <div>
          <h1 className="font-bold pt-4 font-family-poppins text-[24px] text-[#bb1ccc]">Data Traffic Light</h1>
          <p className="pb-6">Real-time monitoring of data contract health and compliance</p>
        </div>
        
        <div className="flex items-center gap-4 mt-1">
          <div className="flex items-center gap-4 bg-white rounded-lg p-3 shadow-sm border">
            <div className="flex items-center gap-2">
              <div className="h-2 w-[10px] bg-green-500 rounded-full shadow-[0_0_8px_rgba(34,197,94,0.4)]"></div>
              <span className="text-sm font-medium text-gray-700">{stats.healthy} Healthy</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="h-2 w-[10px] bg-amber-500 rounded-full shadow-[0_0_8px_rgba(245,158,11,0.4)]"></div>
              <span className="text-sm font-medium text-gray-700">{stats.warning} Warning</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="h-2 w-[10px] bg-red-500 rounded-full shadow-[0_0_8px_rgba(239,68,68,0.4)]"></div>
              <span className="text-sm font-medium text-gray-700">{stats.critical} Critical</span>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex items-center mb-3 border-b border-gray-200">
        <button
          onClick={() => handleTabChange("all")}
          className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${
            activeTab === "all"
              ? "border-[#bb1ccc] text-[#bb1ccc]"
              : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
          }`}
        >
          All Contracts
        </button>
        <button
          onClick={() => handleTabChange("mySubscriptions")}
          className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${
            activeTab === "mySubscriptions"
              ? "border-[#bb1ccc] text-[#bb1ccc]"
              : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
          }`}
        >
          My Subscriptions
        </button>
      </div>

      {/* Filters Section */}
      <div className="bg-white rounded-lg shadow p-4 mb-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex-1"></div>
          
          <div className="flex items-center gap-2">
            <button
              onClick={handleResetFilters}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 flex items-center gap-2"
            >
              <RotateCcw className="h-4 w-4" />
              Reset
            </button>
          </div>
        </div>

        {/* Filters - Always Visible */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {/* Parent Domain */}
          <select
            className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={parentDomain}
            onChange={handleParentDomainChange}
          >
            <option>All Parent Domains</option>
            {getFilterOptions().parentDomains.map((option, index) => (
              <option key={index} value={option}>{option}</option>
            ))}
          </select>

          {/* Domain */}
          <select
            className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={domain}
            onChange={handleDomainChange}
          >
            <option>All Domains</option>
            {getFilterOptions().domains.map((option, index) => (
              <option key={index} value={option}>{option}</option>
            ))}
          </select>

          {/* Sub Domain */}
          <select
            className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={subDomain}
            onChange={handleSubDomainChange}
          >
            <option>All Sub Domains</option>
            {getFilterOptions().subDomains.map((option, index) => (
              <option key={index} value={option}>{option}</option>
            ))}
          </select>

          {/* Product */}
          <select
            className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={product}
            onChange={handleProductChange}
          >
            <option>All Products</option>
            {getFilterOptions().products.map((option, index) => (
              <option key={index} value={option}>{option}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Dashboard Header with Status Filter - COMMENTED OUT */}
      {/* <DashboardHeader
        totalContracts={stats.total}
        healthyCount={stats.healthy}
        warningCount={stats.warning}
        criticalCount={stats.critical}
        searchTerm=""
        setSearchTerm={() => {}}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
        onRefresh={handleRefresh}
        isRefreshing={isRefreshing}
      /> */}

      {/* {selectedFilter !== 'all' && (
        <div className="mb-6">
          <p className="text-gray-600">
            Found {filteredContracts.length} contract{filteredContracts.length !== 1 ? 's' : ''}
            {selectedFilter !== 'all' && ` with status "${selectedFilter}"`}
          </p>
        </div>
      )} */}

      {/* Loading State */}
      {filterLoading ? (
        <div className="flex items-center justify-center py-12">
          <div className="text-center">
            <img src={preloader} alt="Loading..." width={200} className=" mx-auto mb-4" />
            <p className="text-gray-600">Loading contracts...</p>
          </div>
        </div>
      ) : (
        <>
          {/* Contract Cards */}
          <div className='px-4' >
          <div className="grid [grid-template-columns:repeat(auto-fit,minmax(296px,296px))] gap-4 justify-start">
            {filteredContracts.map((contract) => (
              <DataContractCard 
                key={contract.id} 
                {...contract} 
                onViewDetails={() => handleViewDetails(contract)}
              />
            ))}
          </div>
          </div>

          {/* No Results State */}
          {filteredContracts.length === 0 && (
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl text-gray-400">📊</span>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">No contracts found</h3>
              <p className="text-gray-600">
                {parentDomain !== 'All Parent Domains' || domain !== 'All Domains' || subDomain !== 'All Sub Domains' || product !== 'All Products'
                  ? 'Try adjusting your filter criteria'
                  : 'No data contracts are currently configured'
                }
              </p>
            </div>
          )}

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex items-center justify-between mt-6 px-4">
              <span className="text-sm text-gray-600">
                Showing {((currentPage - 1) * pageSize) + 1} to {Math.min(currentPage * pageSize, totalCount)} of {totalCount} results
              </span>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="px-3 py-1 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Previous
                </button>
                <div className="flex items-center space-x-1">
                  {[...Array(Math.min(5, totalPages))].map((_, i) => {
                    let pageNum;
                    if (totalPages <= 5) {
                      pageNum = i + 1;
                    } else if (currentPage <= 3) {
                      pageNum = i + 1;
                    } else if (currentPage >= totalPages - 2) {
                      pageNum = totalPages - 4 + i;
                    } else {
                      pageNum = currentPage - 2 + i;
                    }
                    
                    return (
                      <button
                        key={i}
                        onClick={() => handlePageChange(pageNum)}
                        className={`px-3 py-1 text-sm font-medium rounded-md ${
                          currentPage === pageNum
                            ? 'bg-[#bb1ccc] text-white'
                            : 'text-gray-700 bg-white border border-gray-300 hover:bg-gray-50'
                        }`}
                      >
                        {pageNum}
                      </button>
                    );
                  })}
                </div>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="px-3 py-1 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </>
      )}

      {/* Contract Details Modal */}
      <DataContractDetailsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        contract={selectedContract}
      />
    </div>
  );
}

export default LandingPage;
